import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ViewDetailsIcon, DeleteIcon } from 'ui-component/custom-icons/icons';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import moment from 'moment';
import { FaPlus, FaSearch } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import { Skeleton, Tooltip } from '@mui/material';
import toast from 'react-hot-toast';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import usePermissions from 'hooks/usePermissions';
import usePageTitle from 'hooks/usePageTitle';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import StatusBadge from 'ui-component/StatusBadge';

import { storeSearchOperation, setLoading } from 'store/reducers/mainSlice';
import useIsMobile from 'utils/isMobileUtils';

// ✅ Clear
const index = () => {
    const [setPageTitle] = usePageTitle('Operations');
    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);
    const history = useNavigate();
    const [allPermissions, hasEveryPermission] = usePermissions();
    const [showDelete, setShowDelete] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    const [searchField, setSearchField] = useState();
	const [searchValue, setSearchValue] = useState();
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [filters, setFilters] = useState([]);
    const [activeFilters, setActiveFilters] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);

	const storedSearch = useSelector((state) => state.main.searchOperation);
	const storedFilter = useSelector((state) => state.main.filterOperation);

    useEffect(() => {

        const fetchData = async () => {
            if (storedSearch) {
                setIsLoading(true);
                await handleSearch({ target: { value: storedSearch } });
            } else if (!storedSearch) {
                if (storedFilter && Object.keys(storedFilter).length > 0) {
                    setIsLoading(true);
                    await handleFilterRedux();
                } else {
                    handleFilter()
                }
            }
        };

        fetchData();
    }, [storedSearch, searchField, activeFilters, storedFilter]);

    const getOperationsLists = () => {
        setIsLoading(true);
        api
            .getOperationLists()
            .then((res) => {
                setIsLoading(false);
                isFirstLoad && setIsFirstLoad(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Failed to fetch returns list:', error);
            });
    };
	const handleSearch = (e) => {
		
		let text = e.target.value;
		
		setIsLoading(true);
        setSearchValue(text);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		let timeout = setTimeout(() => {
			dispatch(storeSearchOperation(text));
			setSearchField(text)	
		}, 500);

		setSearchTimeout(timeout);

    };

    const viewData = (id) => {
        history(`/operations/view/${id}/qualitycontrol`);
    };

    useEffect(() => {
        !isFirstLoad && handleFilter();
    }, [activeFilters]);

    const handleFilter = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterOperations(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
        });
    };


    const handleFilterRedux = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterOperations(storedFilter, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
        });
    };


    const handleClose = () => setShowDelete('');

    useEffect(() => {
        if (storedSearch) {
        } else if (storedFilter && Object.keys(storedFilter).length > 0) {
        } else {
            getOperationsLists();
        }
        getFiltersList();
    }, []);

    const getFiltersList = () => {
        api.getOperationsFilter().then((res) => {
            setFilters(res.data);
        });
    };

    const handleDelete = (id) => {
        toast.promise(
            api.deleteOperation(id).then((res) => {
                if (res.status) {
                    setShowDelete('');
                    getOperationsLists()
                }
                return res?.status ? res : abc;
            }),
            {
                loading: 'Deleting Operations...',
                success: (data) => `${data.message}`,
                error: <b>Failed to delete returns</b>
            }
        );
    };

    const deleteOperation = (data) => {
        setShowDelete(data);
    };

    const isMobile = useIsMobile();



	const [dataList, setDataList] = useState([]);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const tableRef = useRef();
	const [showPreloadingRows, setShowPreloadingRows] = useState(true);
	const [totalRecords, setTotalRecords] = useState(0);

	
	const [sortByFilter, setSortByFilter] = useState();




	const initializeData = () => {
		// Initial load
		let request = {}
		request.page = 1;
		request.search = searchField?.length > 2 ? searchField : null;
		
		
		api.getOperationLists(request, activeFilters, searchField, sortByFilter).then((res) => {
			setDataList([]);
			setTimeout(() => {
				setDataList(res?.data?.data?.data || []);

				setHasMore(true);
				setPage(1);
				dispatch(setLoading(false));
				setIsLoading(false);
				// setIsFirstLoad(false);
				setShowPreloadingRows(false);
				setTotalRecords(res?.data?.data?.total || 0);
			}, 300);
		});

	}



	useEffect(() => {
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const timeout = setTimeout(() => {
			const fetchData = async () => {
				if (storedSearch) {
					await handleSearch({ target: { value: storedSearch } });
				}
				setDataList([]);
				initializeData();
				getFiltersList();
			};
			fetchData();
		}, 500); // 500ms debounce

		setSearchTimeout(timeout);

		// Cleanup on unmount or before next effect run
		return () => clearTimeout(timeout);
		// Only trigger when these change
	}, [storedSearch, searchField, storedFilter]);


	useEffect(() => {
		setIsLoading(true);
	}, [activeFilters])


	useEffect(() => {
		setIsLoading(true);
	}, [activeFilters])
	
	useEffect(() => {
		const handleScroll = () => {
			if (!tableRef.current || showPreloadingRows || !hasMore) return;
			const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
			// Trigger only when user reaches the bottom (with a small threshold)
			if (scrollTop + clientHeight >= scrollHeight - 10) {
				loadMoreData();
			}
		};
		const currentRef = tableRef.current;
		if (currentRef) {
			currentRef.addEventListener('scroll', handleScroll);
		}
		return () => {
			if (currentRef) {
				currentRef.removeEventListener('scroll', handleScroll);
			}
		};
	}, [showPreloadingRows, hasMore, dataList]);


    const loadMoreData = () => {
        if (showPreloadingRows || !hasMore) return;
        setShowPreloadingRows(true);
        let request = {};
        request.page = page + 1;
        request.search = searchField?.length > 2 ? searchField : null;

        
        api.getOperationLists(request, activeFilters, searchField, sortByFilter).then((res) => {
            // Use pagination meta from backend
            const nextPage = res?.data?.data?.meta?.current_page || request.page;
            const lastPage = res?.data?.data?.meta?.last_page || nextPage;
            if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
                setHasMore(false);
            } else {
                setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
                setPage(nextPage);
            }
            setShowPreloadingRows(false);
        });
    };




    return (
		<>
			<div className="row justify-content-center m-0">
			
				<div className="medium-sized-container">
					<div className="col-xl-12 col-lg-12">
						<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<h5 style={{ textAlign: 'center' }}>Operations</h5>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<PermissionAllowed permissions={['Create Operations']}>
										<button
											className="btn btn-primary btn-outlined-main white-var"
											onClick={() => {
												history('/operations/create');
											}}
										>
											<span className="menuIcon">
												<FaPlus style={{ fontSize: '13px', marginTop: '-3px' }} />
											</span>
											<span>New</span>
										</button>
									</PermissionAllowed>
								</div>
							</div>
						</div>
						<div className="section-head-new mar102000 hide-on-mobile">
							<div className="actions">
								<PermissionAllowed permissions={['Create Operations']}>
									<button
										className="bulk-action btn-primary btn-outlined-main-primary  white-var"
										onClick={() => {
											history('/operations/create');
										}}
									>
										<span className="menuIcon">
											<FaPlus style={{ fontSize: '13px', marginTop: '-3px' }} />
										</span>
										<span>New</span>
									</button>
								</PermissionAllowed>
							</div>
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: 10,
								paddingTop: 0,
								paddingBottom: 5,
								paddingLeft: 20,
								paddingRight: 20
							}}
							className="show-on-mobile"
						>
							<form className="form-inline navbar-search" style={{ flex: 1 }}>
								<div style={{ position: 'relative', width: '100%' }}>
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
                                    	value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%', paddingRight: 36 }}
									/>
									<span
										className="searchIcon"
										style={{
											position: 'absolute',
											right: 10,
											top: '50%',
											transform: 'translateY(-50%)',
											color: '#888',
											pointerEvents: 'none'
										}}
									>
										<FaSearch />
									</span>
								</div>
							</form>
							<div style={{ flexShrink: 0 }}>
								<Filter
									activeFilters={activeFilters}
									onSubmit={setActiveFilters}
									filters={filters}
									multi={undefined}
									source={'operation'}
									noScrolling={true}
								/>
							</div>
						</div>
						<div className={`card shadow-sm  bg-white mb-4  ${isMobile ? 'table-card shorter-table' : ''}`}>
							<div className=" align-items-center justify-content-between TableSerachBar">
								<div>
									<div className="actions">
										<div style={{ margin: '0 5px' }}>
											<Filter
												activeFilters={activeFilters}
												onSubmit={setActiveFilters}
												filters={filters}
												multi={undefined}
												source={'operation'}
												noScrolling={true}
											/>
										</div>
									</div>
								</div>
								<form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
									<div className="input-group">
										<input
											type="text"
											className="form-control bg-white border"
											placeholder="Search"
											aria-label="Search"
											aria-describedby="basic-addon2"
											onChange={handleSearch}
											style={{ width: '100%' }}
                                    		value={searchValue || ''}
										/>
										<span className="searchIcon">
											<FaSearch />
										</span>
									</div>
								</form>
							</div>
							{!isMobile ? (
								<div
									className="table-responsive-xl tableData customersList"
									ref={tableRef}
									style={{
										height: 'calc(100vh - 260px)',
										overflowY: 'auto',
										scrollbarWidth: 'thin',
										scrollbarColor: '#0966ff transparent'

									}}
								>
									<table className="table pm-table">
										<thead>
											<tr className="sticky-header">
												<th scope="col">Reference No</th>
												<th scope="col text-left">Quantity</th>
												<th scope="col text-left" style={{ width: '150px' }}>Status</th>
												<th scope="col text-left" style={{ width: '130px' }}>Date</th>
											</tr>
										</thead>
										<tbody>
											{isLoading ? (
												[...Array(50)].map((e, i) => (
													<tr style={{ height: '35px' }} key={i}>
														{[...Array(4)].map((e, i) => (
															<td>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
															</td>
														))}
													</tr>
												))
											) : (
												<>
												
													{dataList?.length > 0 && (
														dataList?.map((row, index) => {
															return (
																<tr key={index} className="hover-row">
																	<td
																		className="align-middle font14"
																		onClick={() => {
																			if (hasEveryPermission(['View Operations Details'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Operations Details']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		{row?.reference_number}
																	</td>
																	<td
																		className="align-middle font14"
																		onClick={() => {
																			if (hasEveryPermission(['View Operations Details'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Operations Details']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		{row?.quantity.toLocaleString()}
																	</td>
																	<td
																		className="align-middle font14"
																		onClick={() => {
																			if (hasEveryPermission(['View Operations Details'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Operations Details']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		<div style={{ width: '110px' }}>
																			<StatusBadge itemStatus={row?.status} />
																		</div>
																	</td>
																	<td
																		className="align-middle font14"
																		onClick={() => {
																			if (hasEveryPermission(['View Operations Details'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Operations Details']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		{moment(row?.created_date).format(CommonDateOnlyFormat)}
																	</td>

																	<td className="hover-button-container">
																		<div>
																			<div className="hover-button">
																				<PermissionAllowed permissions={['View Operations Details']}>
																					<Tooltip title={'View'} arrow placement="top">
																						<div
																							className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																							style={{ marginLeft: '8px' }}
																							onClick={() => {
																								viewData(row.id);
																							}}
																						>
																							<ViewDetailsIcon height={'16'} width={'16'} />
																						</div>
																					</Tooltip>
																				</PermissionAllowed>

																				<PermissionAllowed permissions={['Delete Operations']}>
																					<Tooltip title={'Delete'} arrow placement="top">
																						<div
																							className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																							style={{ marginLeft: '8px' }}
																							onClick={() => {
																								deleteOperation(row);
																							}}
																						>
																							<div style={{ margin: 'auto 3px' }}>
																								<DeleteIcon height="14px" width="14px" />
																							</div>
																						</div>
																					</Tooltip>
																				</PermissionAllowed>
																			</div>
																		</div>
																	</td>
																</tr>
															);
														})
													)}
													{showPreloadingRows && (
														[...Array(100)].map((e, i) => (
															<tr style={{ height: '35px' }} key={i}>
																{[...Array(4)].map((e, i) => (
																	<td>
																		<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																	</td>
																))}
															</tr>
														))
													)}
												
													{(dataList?.length < 1 && !isLoading) && (
														<tr className="no-hover">
															<td colSpan={6} className="whitebg">
																<div className="not-found-container">
																	<div className="not-found-icon">
																		<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																	</div>
																	<h6 className="not-found-text">No Data Available</h6>

																	<PermissionAllowed permissions={['Create Operation']}>
																		<Link to={'/opearations/create'} className="btn btn-primary btn-outlined-main">
																			Create Operation
																		</Link>
																	</PermissionAllowed>
																</div>
															</td>
														</tr>
													)}
												</>
											)}
										</tbody>
									</table>
								</div>
							) : (
								<div
									className="picklists-mobile-list"
									ref={tableRef}
									style={{
										height: `calc(100dvh - ${Object.keys(activeFilters).length === 0 ? '305px' : '332px' })`,
										overflowY: 'auto',
										display: 'flex',
										flexDirection: 'column'
									}}
								>
									{isLoading ? (
										[...Array(7)].map((_, i) => (
											<div className="inv-cards-list d-md-none" style={{ padding: '12px 0' }}>
												{[...Array(15)].map((_, idx) => (
													<div
														key={idx}
														className="order-list-card"
														style={{
															background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
															marginBottom: 10,
															borderRadius: 12,
															padding: 16,
															minHeight: 90,
															display: 'flex',
															flexDirection: 'column',
															gap: 10,
														}}
													>
														{[...Array(3)].map((__, i) => (
															<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
																<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
															</div>
														))}
													</div>
												))}
											</div>
										))
									) : (
										<>
											{dataList.map((row, index) => (
												<div
													style={{
														display: 'flex',
														padding: '5px 20px',
														flexDirection: 'row',
														background: index % 2 === 0 ? '#f9f9f9' : '#fff',
														borderBottom: '1px solid #eee',
														justifyContent: 'space-between'
													}}
													key={row.id || index}
													onClick={() => hasEveryPermission(['View Operations Details']) && viewData(row.id)}
												>
													<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', gap: 10 }}>
														<div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: '100%' }}>
															<div style={{ display: 'flex', gap: 5, fontWeight: 500 }}>
																<div>Reference No:</div>
																<div
																	style={{
																		cursor: hasEveryPermission(['View Operations Details']) ? 'pointer' : 'not-allowed',
																		color: '#316aff'
																	}}
																>
																	{row?.reference_number}
																</div>
															</div>
															<div
																className="picklist-mobile-row"
																style={{
																	cursor: hasEveryPermission(['View Operations Details']) ? 'pointer' : 'not-allowed'
																}}
															>
																<div>QTY:</div>
																<div>{row?.quantity}</div>
																<div> | </div>
																<div>{moment(row?.created_date).format(CommonDateOnlyFormat)}</div>
															</div>
															<div
																className="picklist-mobile-row"
																style={{
																	cursor: hasEveryPermission(['View Operations Details']) ? 'pointer' : 'not-allowed'
																}}
															>
																<div>Owner:</div>
																<div>{row?.created_by?.name}</div>
															</div>
														</div>
														<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
															<div style={{ width: '90px' }}>
																<StatusBadge itemStatus={row?.status} />
															</div>
															<div className="picklist-mobile-actions" >
																<PermissionAllowed permissions={['View Operations Details']}>
																	<Tooltip title={'View'} arrow placement="top">
																		<div
																			className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																			style={{ minWidth: 'unset' }}
																			onClick={(e) => {
																				e.stopPropagation();
																				viewData(row.id);
																			}}
																		>
																			<ViewDetailsIcon height={'16'} width={'16'} />
																		</div>
																	</Tooltip>
																</PermissionAllowed>
																<PermissionAllowed permissions={['Delete Operations']}>
																	<Tooltip title={'Delete'} arrow placement="top">
																		<div
																			className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																			style={{ minWidth: 'unset' }}
																			onClick={(e) => {
																				e.stopPropagation();
																				deleteOperation(row);
																			}}
																		>
																			<div style={{ margin: 'auto 3px' }}>
																				<DeleteIcon height="14px" width="14px" />
																			</div>
																		</div>
																	</Tooltip>
																</PermissionAllowed>
															</div>
														</div>
													</div>
												</div>

											))}
																						
											{showPreloadingRows && (
												[...Array(100)].map((_, idx) => (
													<div
														key={idx}
														className="order-list-card"
														style={{
															background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
															marginBottom: 10,
															borderRadius: 12,
															padding: 16,
															minHeight: 90,
															display: 'flex',
															flexDirection: 'column',
															gap: 10
														}}
													>
														{[...Array(4)].map((__, i) => (
															<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
																<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
															</div>
														))}
													</div>
												))
											)}
												
											{(dataList?.length < 1 && !isLoading) && (
												<div className="w-100">
													<div className="not-found-container">
														<div className="not-found-icon">
															<TbDatabaseExclamation />
														</div>
														<h6 className="not-found-text">No Data Available</h6>

														<PermissionAllowed permissions={['Create Operation']}>
															<Link to={'/opearations/create'} className="btn btn-primary btn-outlined-main">
																Create Operation
															</Link>
														</PermissionAllowed>
													</div>
												</div>
											)}
										</>
									)}
								</div>
							)}
						

							<div
								className="hide-on-mobile"
								style={{
									padding: '10px 0px 10px 20px',
									borderTop: '1px solid #e0e0e0e0',
									display: 'flex',
									gap: '5px',
									justifyContent: 'space-between',
									height: '45px',
								}}
							>

								<div className="flex align-items-center" style={{ gap: '10px' }}>
									

								</div>
								<div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
									{isLoading ? (
										<div style={{ width: '100px' }}>
											<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
										</div>
									) : (
										<>
											<div className="text-gray-800">Total Record:</div>
											<div className="fw-500">
													{totalRecords.toLocaleString('en-US')}
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{showDelete && (
				<DeleteConfirmation
					show={showDelete}
					handleClose={handleClose}
					handleDelete={handleDelete}
					title="Confirm"
					message={`Are you sure you want to delete ${showDelete?.reference_number}?`}
				/>
			)}

		</>
	);
};

export default index;
